module.exports = __webpack_public_path__ + "img/banner-approval.23c9dfb2.png";